import { createSelector } from 'reselect'

const getState = state => state.AssessmentStore

const getFetchRequest = state => getState(state).fetchAssessmentsRequest
const getDeletingAssessmentRequests = state =>
  getState(state).deletingAssessmentRequests

const getDeletingAssessmentRequest = (state, id) =>
  getDeletingAssessmentRequests(state)[id] || {
    pending: false,
    requestError: null
  }

const getAssessments = state => getState(state).assessments

const getAssessmentsMap = createSelector(
  [getAssessments],
  assessments => (!assessments ? {} : assessments.entities.assessments)
)

const getAssessmentsResult = createSelector(
  [getAssessments],
  assessments => (!assessments ? [] : assessments.result)
)

const getAssessmentsList = createSelector(
  [getAssessmentsResult, getAssessmentsMap],
  (result, assessmentsMap) => result.map(id => assessmentsMap[id])
)

const getAssessment = (state, id) => getAssessmentsMap(state)[id]

export {
  getFetchRequest,
  getAssessmentsList,
  getAssessment,
  getDeletingAssessmentRequest
}
